<script setup>
	import { ref, reactive, computed, onMounted, watch } from 'vue';

	const props = defineProps({
		list: {
			type: [Array, Object],
			default: [],
		},
	});

	const emit = defineEmits(['change']);

	const page = ref(1);

	const pages = computed(() => {
		return Math.ceil(props.list?.data.length / props.list.per_page);
	});

	const pagesObj = computed(() => {
		let obj = {
			first: 1,
			last: pages.value,
			middle: [],
			ellipsisStart: false,
			ellipsisEnd: false,
		};

		if (pages.value > 5) {
			if (page.value <= 3) {
				obj.middle = [2, 3, 4];
				obj.ellipsisEnd = true;
			} else if (page.value >= pages.value - 2) {
				obj.middle = [pages.value - 3, pages.value - 2, pages.value - 1];
				obj.ellipsisStart = true;
			} else {
				obj.middle = [page.value - 1, page.value, page.value + 1];
				obj.ellipsisStart = true;
				obj.ellipsisEnd = true;
			}
		} else {
			let arrayPagesDefault = [];
			for (let i = 2; i < pages.value; i++) {
				arrayPagesDefault.push(i);
			}
			obj.middle = arrayPagesDefault;
		}

		return obj;
	});

	const paginated = computed(() => {
		return props.list.data.slice((page.value - 1) * props.list.per_page, page.value * props.list.per_page);
	});

	onMounted(() => {
		emit('change', paginated.value);
	});

	// Watch the list, if it changes, make sure the current page is still available, if not, go to the latest page available
	watch(
		() => props.list.data,
		() => {
			if (page.value > pages.value || page.value == null) {
				page.value = pages.value;
			}
			if (page.value == 0) {
				page.value = 1;
			}
			emit('change', paginated.value);
		},
	);

	const next = () => {
		window.scrollTo({ top: 0, left: 0 });
		if (page.value < pages.value) {
			page.value++;
			emit('change', paginated.value);
		}
	};

	const prev = () => {
		window.scrollTo({ top: 0, left: 0 });
		if (page.value > 1) {
			page.value--;
			emit('change', paginated.value);
		}
	};

	const set = (p) => {
		window.scrollTo({ top: 0, left: 0 });
		page.value = p;
		emit('change', paginated.value);
	};
</script>

<template>
	<div class="flex items-center justify-center rounded-xl p-1 gap-1 flex-wrap" v-if="list?.last_page > 1">
		<a
			v-for="link in props.list.links"
			:key="link.url"
			:href="link.url"
			class="transition ease-in rounded-xl p-2 cursor-pointer w-8 aspect-square flex items-center justify-center"
			:class="{
				'text-gray-600 font-bold': link.active,
				'text-gray-400': !link.active,
			}"
			v-html="link.label">
		</a>
	</div>
</template>
